module.exports = "/fast-coin/img/coin/anim/out_2/out_2_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_004.png
// module id = 2310
// module chunks = 5